var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4451 14.7733C15.3202 14.7733 16.8402 13.2532 16.8402 11.3782C16.8402 9.50313 15.3202 7.98309 13.4451 7.98309C11.5701 7.98309 10.05 9.50313 10.05 11.3782C10.05 13.2532 11.5701 14.7733 13.4451 14.7733Z",
    stroke: "#292D32",
    strokeWidth: 1.41498
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3269 9.39824C6.4706 -0.0253316 20.4318 -0.0144496 22.5647 9.40912C23.8161 14.937 20.3774 19.6162 17.3632 22.5107C15.176 24.6218 11.7156 24.6218 9.51748 22.5107C6.51413 19.6162 3.07551 14.9261 4.3269 9.39824Z",
    stroke: "#292D32",
    strokeWidth: 1.41498
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9edeeed78c88957de17186e92cc4cb04.svg";
export { ForwardRef as ReactComponent };